"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.ExpandButton = exports.CaptionText = exports.ButtonContainer = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'block',
  padding: theme.spacing(0, 3),
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(0, 4, 0, 0)
  }
}));
const CaptionText = exports.CaptionText = (0, _mui.styled)(_mui.Typography)({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 15,
  overflow: 'hidden',
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  wordBreak: 'break-word',
  hyphens: 'auto',
  textAlign: 'center'
});
const ButtonContainer = exports.ButtonContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: theme.spacing(1)
}));
const ExpandButton = exports.ExpandButton = (0, _mui.styled)(_components.IconButton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isCaptionExpanded'])
})(({
  theme,
  isCaptionExpanded
}) => ({
  transform: 'rotate(0deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  }),
  ...(isCaptionExpanded && {
    transform: 'rotate(180deg)'
  })
}));
